import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { v1 as uuid } from 'uuid';
import { firebaseConfig } from '../config';
import axios from 'axios';

import { useDispatch } from '../redux/store';
import { setProfileData, updateUserActivity } from '../redux/slices/user';
// ----------------------------------------------------------------------

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.firestore();
}

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const reducer = (state, action) => {
  if (action.type === 'INITIALISE') {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  }

  return state;
};

const AuthContext = createContext({
  ...initialState,
  method: 'firebase',
  login: () => Promise.resolve(),
  register: () => Promise.resolve(),
  loginWithGoogle: () => Promise.resolve(),
  loginWithFaceBook: () => Promise.resolve(),
  loginWithTwitter: () => Promise.resolve(),
  logout: () => Promise.resolve()
});

AuthProvider.propTypes = {
  children: PropTypes.node
};

function AuthProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);
  const dispatchData = useDispatch();
  let uSprofile = {}

  useEffect(
    async () =>
      await firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          const docRef = firebase.firestore().collection('users').doc(user.uid);
          docRef
            .get()
            .then((doc) => {
              if (doc.exists) {
                setProfile(doc.data());
                dispatchData(setProfileData(doc.data()));
              }
            })
            .catch((error) => {
              console.error(error);
            });

          dispatch({
            type: 'INITIALISE',
            payload: { isAuthenticated: true, user }
          });
        } else {
          dispatch({
            type: 'INITIALISE',
            payload: { isAuthenticated: false, user: null }
          });
        }
      }),
    [dispatchData]
  );

  const login = async (email, password) => {
    let user = await firebase.auth().signInWithEmailAndPassword(email, password);
    
    await updateUserActivity(user.user.uid)

    return user;
  }

  const loginWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    return firebase.auth().signInWithPopup(provider);
  };

  const loginWithFaceBook = () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    return firebase.auth().signInWithPopup(provider);
  };

  const loginWithTwitter = () => {
    const provider = new firebase.auth.TwitterAuthProvider();
    return firebase.auth().signInWithPopup(provider);
  };

  const createStartUserData = async (uid) => {
    // стартовые данные для юзера
    await axios.get('https://api.asystent.biz/api/messages-hello/'+uid);

    try {
      let initialQuery = await firebase.firestore().collection('offers_templates').where("isbase","==",true).limit(1);
      let documentSnapshots = await initialQuery.get();
      let documentData = documentSnapshots.docs.map(document => document.data());
      let template = documentData[0]

      let templateChooseQuery = await firebase.firestore().collection('offers_templates').doc(template.uid).get()
      
      const fetchedData = []
      await firebase.firestore().collection('offers_templates').doc(template.uid).collection('questions').get().then(response => {
        response.forEach(document => {
          let fetched = {
            ...document.data()
          };
          fetchedData.push(fetched);
        });
      });

      const id = uuid()
      const offer = {
        id: id,
        ...templateChooseQuery.data(),
        questions: [...fetchedData],
        status: false,
        video: "",
        video_uploading: false,
        videoApproved: false,
        user: uid,
        time: new Date().getTime()
      }
      await firebase.firestore().collection('offers').doc(id).set(offer)
    } catch (e) {
      console.log(e)
    }
  }  

  const register = (email, password, phone, category, city, firstName, lastName) =>
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(async (res) => {
        firebase
          .firestore()
          .collection('users')
          .doc(res.user.uid)
          .set({
            uid: res.user.uid,
            email,
            phone: phone,
            category: category?category:4,
            city: city?city:0,
            date: Math.floor(Date.now() / 1000),
            username: firstName + ' ' + lastName,
            role: "user",
            status: "1",
            token: null,
          });

          //start user data
          let newuser = {
            email: email,
            phone: phone,
            status: 1,
            uid: res.user.uid,
            username: firstName + ' ' + lastName,
            token:"",
            bio:"",
            category: category?category:4,
            date: Math.floor(Date.now() / 1000),
            photo:"",
            city: city?city:1,
          }
    
          await axios.post('https://api.asystent.biz/api/candidates', JSON.stringify({
            data: newuser
          }));

          res.user.uid && createStartUserData(res.user.uid);
  });

  const logout = async () => {
    await firebase.auth().signOut();
  };

  const resetPassword = async (email) => {
    await firebase.auth().sendPasswordResetEmail(email);
  };

  const auth = { ...state.user };

  if(profile) {
    uSprofile = profile
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'firebase',
        user: {
          id: auth.uid,
          displayName: uSprofile.username || '',
          email: auth.email || '',
          photoURL: uSprofile.photo || '',
          phoneNumber: uSprofile.phone || '',
          phoneNumberVirify: uSprofile.phone_verify || '',
          country: uSprofile.country || '',
          address: uSprofile.address || '',
          state: uSprofile.state || '',
          city: uSprofile.city || '',
          zipCode: uSprofile.zipCode || '',
          about: uSprofile.bio || '',
          role: uSprofile.role || '',
          // role: ADMIN_EMAILS.includes(auth.email) ? 'admin' : 'user', //uSprofile.role
          isPublic: uSprofile.isPublic || false
        },
        login,
        register,
        loginWithGoogle,
        loginWithFaceBook,
        loginWithTwitter,
        logout,
        resetPassword
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
